module.exports = __webpack_public_path__ + "img/austral-sign.a51f09ad.svg";